import { AxiosResponse } from "axios";
import { createContext } from "react";
import { ReservationLoginRequest, ReservationLoginResponse, ValidateSessionResponse } from "../actions/reservation-auth-actions";

export type AuthContextType = {
  user: any,
  setUser: (user: any) => void,
  reservationLogin: (request: ReservationLoginRequest) => Promise<AxiosResponse<ReservationLoginResponse, any>>,
  validateSession: () => Promise<AxiosResponse<ValidateSessionResponse, any>>,
  cleanUp: () => void,
  isSessionExpired: () => boolean
}

export const AuthContext = createContext<AuthContextType>({
  user: null,
  setUser: (user: any) => { },
  reservationLogin: (request: ReservationLoginRequest) => null as any,
  validateSession: () => null as any,
  cleanUp: () => { },
  isSessionExpired: () => false
});
